module.exports = __webpack_public_path__ + "static/media/guidance_background.39ea6a39.png";